import { Component } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef
} from "@angular/material/legacy-dialog";
import { CtButtonConfiguration, CtControlConfiguration, CtControlTypes, CtThemeTypes, MAT_RAISED_PRIMARY, MAT_RAISED_WARN } from '@ctsolution/ct-framework';
import { NoteDialogComponent } from 'projects/ct-manager/src/app/_core/services/note-services/note-dialog/note-dialog.component';

@Component({
  selector: 'app-work-order-quotation-dialog',
  templateUrl: './work-order-quotation-dialog.component.html',
  styleUrls: ['./work-order-quotation-dialog.component.scss']
})
export class WorkOrderQuotationDialogComponent {

 
   control: CtControlConfiguration = CtControlConfiguration
   .create()
   .setName('CreateDocumentPdf')
   .setType(CtControlTypes.CHECKBOX)
   .setTheme(CtThemeTypes.MATERIAL)
   .setValue(true)
   .setLabel('workOrderPdfDialogCheckbox');
  
   form: FormGroup;
 
   constructor(
     private fb: FormBuilder,
     private dialogRef: MatDialogRef<NoteDialogComponent>) {
 
     this.form = this.fb.group({});
     this.control.setFormParent(this.form)

 
   }
 
   cancelButton: CtButtonConfiguration = CtButtonConfiguration
     .create()
     .setLabel("CT_PAGE.CT_FORM.cancel")
     .setAction(() => this.cancel())
     .setMatherialOptions(MAT_RAISED_WARN)
 
   submitButton: CtButtonConfiguration = CtButtonConfiguration
     .create()
     .setLabel("CT_PAGE.CT_FORM.save")
     .setClass('ct-model-submit-button')
     .setAction(() => this.submit())
     .setMatherialOptions(MAT_RAISED_PRIMARY);


     submit() {

        const value = this.form.get('CreateDocumentPdf')?.value;

        this.dialogRef.close({
          Accepted: true,
          CreateDocumentPdf: value
        } as WorkOrderQuotationDialogResult);

     }

     cancel(){

        this.dialogRef.close({
          Accepted: false,
          CreateDocumentPdf: false
        } as WorkOrderQuotationDialogResult);

     }

 
 }

 export interface WorkOrderQuotationDialogResult {

    Accepted: boolean;
    CreateDocumentPdf: boolean;


 }